export const ContentTypeConstants = {
    pdf: 'application/pdf',
    csv: ' text/csv'
};